import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import CarList from './pages/CarList';
import CarDetail from './pages/CarDetail';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import LegalNotice from './pages/LegalNotice';
import './App.css';

// Composant pour vérifier le token d'accès admin
const AdminAccessGate = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('key');
  
  // Token secret depuis les variables d'environnement
  const ADMIN_ACCESS_TOKEN = process.env.REACT_APP_ADMIN_ACCESS_TOKEN;
  
  if (token && token === ADMIN_ACCESS_TOKEN) {
    // Token valide, autoriser l'accès
    sessionStorage.setItem('adminAccessGranted', 'true');
    return <AdminLogin />;
  }
  
  // Token invalide, rediriger vers l'accueil
  return <Navigate to="/" replace />;
};

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {!isAdminPage && <Header />}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/stock" element={<CarList />} />
          <Route path="/voiture/:id" element={<CarDetail />} />
          <Route path="/admin" element={<AdminAccessGate />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/mentions-legales" element={<LegalNotice />} />
        </Routes>
      </main>
      {!isAdminPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
